'use client';

import { useTranslation } from '@/context/LanguageContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAward, faPencilAlt, faUserCheck, faCheck } from '@fortawesome/free-solid-svg-icons';
import { siteConfig } from '@/config/site';

export default function AdmissionSection() {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();
  const siteName = siteConfig.name || "UNMUL";

  return (
    <section id="admission" className="py-24 bg-unmulDarkGreen relative overflow-hidden text-white">
      <div className="absolute inset-0 opacity-10 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]"></div>
      
      <div className="container mx-auto px-6 relative z-10">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-serif font-bold">{t('admissionSection.title', { siteName, year: currentYear })}</h2>
          <p className="text-green-200 mt-4">{t('admissionSection.subtitle', { siteName })}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {/* SNBP */}
          <div className="bg-white/10 backdrop-blur-sm border border-white/10 p-8 rounded-2xl hover:bg-white/20 transition group">
            <div className="text-4xl text-blue-400 mb-4"><FontAwesomeIcon icon={faAward} /></div>
            <h3 className="text-2xl font-bold mb-2">{t('admissionSection.snbp.title')}</h3>
            <p className="text-sm text-gray-300 mb-6">{t('admissionSection.snbp.desc')}</p>
            <ul className="text-sm space-y-2 mb-6 text-gray-300">
              <li><FontAwesomeIcon icon={faCheck} className="text-green-400 mr-2" />{t('admissionSection.snbp.item1')}</li>
              <li><FontAwesomeIcon icon={faCheck} className="text-green-400 mr-2" />{t('admissionSection.snbp.item2')}</li>
              <li><FontAwesomeIcon icon={faCheck} className="text-green-400 mr-2" />{t('admissionSection.snbp.item3')}</li>
            </ul>
            <a href="#" className="block w-full py-3 text-center bg-blue-700 hover:bg-blue-800 rounded-lg font-bold transition">{t('admissionSection.snbp.button')}</a>
          </div>

          {/* SNBT */}
          <div className="bg-unmulYellow text-unmulDarkGreen p-8 rounded-2xl shadow-xl transform scale-105 border-4 border-white/20 relative">
            <div className="absolute top-0 right-0 bg-red-600 text-white text-xs font-bold px-3 py-1 rounded-bl-lg">{t('admissionSection.snbt.popular')}</div>
            <div className="text-4xl mb-4"><FontAwesomeIcon icon={faPencilAlt} /></div>
            <h3 className="text-2xl font-bold mb-2">{t('admissionSection.snbt.title')}</h3>
            <p className="text-sm font-semibold mb-6">{t('admissionSection.snbt.desc')}</p>
            <ul className="text-sm space-y-2 mb-6">
              <li><FontAwesomeIcon icon={faCheck} className="mr-2" />{t('admissionSection.snbt.item1')}</li>
              <li><FontAwesomeIcon icon={faCheck} className="mr-2" />{t('admissionSection.snbt.item2')}</li>
              <li><FontAwesomeIcon icon={faCheck} className="mr-2" />{t('admissionSection.snbt.item3')}</li>
            </ul>
            <a href="#" className="block w-full py-3 text-center bg-white text-unmulDarkGreen hover:bg-gray-100 rounded-lg font-bold transition">{t('admissionSection.snbt.button')}</a>
          </div>

          {/* Mandiri */}
          <div className="bg-white/10 backdrop-blur-sm border border-white/10 p-8 rounded-2xl hover:bg-white/20 transition group">
            <div className="text-4xl text-green-400 mb-4"><FontAwesomeIcon icon={faUserCheck} /></div>
            <h3 className="text-2xl font-bold mb-2">{t('admissionSection.mandiri.title')}</h3>
            <p className="text-sm text-gray-300 mb-6">{t('admissionSection.mandiri.desc')}</p>
            <ul className="text-sm space-y-2 mb-6 text-gray-300">
              <li><FontAwesomeIcon icon={faCheck} className="text-green-400 mr-2" />{t('admissionSection.mandiri.item1')}</li>
              <li><FontAwesomeIcon icon={faCheck} className="text-green-400 mr-2" />{t('admissionSection.mandiri.item2')}</li>
              <li><FontAwesomeIcon icon={faCheck} className="text-green-400 mr-2" />{t('admissionSection.mandiri.item3')}</li>
            </ul>
            <a href="#" className="block w-full py-3 text-center bg-unmulGreen border border-white/30 hover:bg-green-700 rounded-lg font-bold transition">{t('admissionSection.mandiri.button')}</a>
          </div>
        </div>
      </div>
    </section>
  );
}
